<template>
    <section>
        <transition-group name="modal">
            <div id="brand" class="modal-mask" key="brand">
                <img src="../../../assets/croix.png" width="20" height="20" alt="" @click="close" class="cross fright abs pointer" />
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody">
                            <div class="modalContent txtCenter">
                                <h2 class="ff-light">{{ $t("favorite.title") }}</h2>
                                <p>{{ $t("favorite.name") }}</p>
                                <input id="favoriteName" placeholder="Favorite name" type="text" v-model="favoriteName" />
                            </div>
                            <div>
                                <button class="btn block pointer center" @click="saveFavorite">{{ $t("favorite.save") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
//    import { builderMixin } from '../mixins/builder'
import httpService from "../../service";
import Vuex from "vuex";

import Vue from "vue";

import Toast from "vue-easy-toast";
import { planoMixin } from "../mixins/plano";
import { stateMixin } from "../mixins/state";

Vue.use(Toast);

export default {
    data: () => ({
        favoriteName: ""
    }),
    mixins: [planoMixin, stateMixin],
    directives: {},
    props: {},
    methods: {
        close() {
            this.setShowModalFavorite(false);
            //                this.$emit('closeModal', false)
        },
        saveFavorite() {
            let favs = this.getFavModule;
            let favorite = favs[favs.length - 1];
            let svgFav = favorite.svg.outerHTML.replace(new RegExp("&nbsp;", "g"), ",");
            delete favorite.svg;
            // favorite.modules.forEach((module) => {
            //     module.svg = module.svg.outerHTML
            // })

            let favModule = {
                svg: svgFav,
                content: favorite,
                name: this.favoriteName
            };

            httpService.post("/favorites", JSON.stringify(favModule)).then(response => {
                Vue.toast("ENREGISTREMENT DANS FAVORIS REUSSI", {
                    id: "my-toast",
                    className: ["my-toast", "toast-warning", "flexContainer"],
                    horizontalPosition: "right",
                    verticalPosition: "bottom",
                    mode: "queue"
                });
                this.setShowModalFavorite(false);
                //                        this.$emit('closeModal', false)
            });
        }
    },
    computed: {
        ...Vuex.mapGetters({
            //                getSelectModules: 'plano/status/getSelectModules',
            getFavModule: "plano/status/getFavModule"
        })
    },
    created() {}
};
</script>

<style lang="scss" scoped>
._selectedCampaign,
._selectedZone {
    color: #0000f0;
    font-weight: bold;
}

/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 50px;
        right: 50px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            background: #fff;
            width: 500px;
            height: 250px;
            border-radius: 4px;
            padding: 15px;
            margin: auto;
            .modalContent {
                h2 {
                    font-size: 1.6rem;
                }
                p {
                    font-size: 1.4rem;
                    margin: 30px 0;
                }
                #favoriteName {
                    background-color: transparent;
                    border: none;
                    border-bottom: 1px solid #343434;
                    margin-bottom: 30px;
                    font-family: Roboto;
                    font-size: 14px;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// ModalFavorite.vue?611408d2